import { getHashFile } from 'src/components/views/EscritosLexnet/components/shared/components/Adjuntos/components/types'
import { useEscritoContext } from 'src/contexts/EscritoContext/EscritoContext'
import useDocument from 'src/hooks/useDocument'
import useExpedient from 'src/hooks/useExpedient'
import {
  DocumentDb,
  DocumentoPrincipalType,
  Escrito,
  Nig,
  ExpedientDataFromLexon
} from 'src/interfaces/EscritosLegales'
import { Document, ExpedientDataFromLexonParsed } from 'src/interfaces/lexon'
import { getExpedientData } from 'src/services/ExpedientsService'
import { getDocument, getDocumentData } from 'src/services/Lexon/DocumentService'

type useEscritoOutput = {
  setFormDocument: (
    tipoEscritoId: number,
    documentId: number,
    entityId: number,
    entityTypeId: number,
    companyId: number
  ) => Promise<boolean>
}

export default function useEscrito(): useEscritoOutput {
  const { setData } = useEscritoContext()
  const { mapFromDb } = useDocument()
  const { mapExpFromDb } = useExpedient()

  const setFormDocument = async (
    tipoEscritoId: number,
    documentId: number,
    entityId: number,
    entityTypeId: number,
    companyId: number
  ): Promise<boolean> => {
    const documentDb: DocumentDb | null = await getDocumentData(documentId)
    const document: Document | null = mapFromDb(documentDb)
    let expedientDb: ExpedientDataFromLexon | null = null
    let expedient: ExpedientDataFromLexonParsed | null = null
    const emptyNig: Nig = { value: '', N1: '', N2: '', N3: '', N4: '', N5: '' }

    if (entityTypeId === 1) {
      expedientDb = await getExpedientData(entityId, companyId)
      expedient = mapExpFromDb(expedientDb)
    }

    if (!document) {
      return false
    }

    const file: File = await getDocument(document)

    if (!file) {
      return false
    }

    const hash: string | null = await getHashFile(file)

    const escrito: Escrito = {} as Escrito

    escrito.tipoMensaje = tipoEscritoId
    // TODO: Añadir nig, juzgado y intervinientes
    escrito.procedimiento = {
      numeroProcedimiento: expedient?.proceeding ?? ''
    }
    escrito.destino = expedient?.destino ?? null
    escrito.orden = expedient?.orden ?? null

    escrito.NIG = expedient?.nig ?? emptyNig

    escrito.tipoEscrito = {
      id: tipoEscritoId,
      codigo: tipoEscritoId.toString(),
      descripcion: ''
    }
    escrito.intervinientes = expedient?.interveners
    if (expedient?.interveners) {
      escrito.intervinientesFromLexonValidated = false
    }
    escrito.documentoPrincipalArchivo = file
    escrito.documentoPrincipal = [
      {
        archivo: document.initialFile,
        descripcion: document.description,
        hash,
        pendienteCompletar: false,
        sign: true,
        subtipo: null
      } as DocumentoPrincipalType
    ]

    setData(escrito)

    return true
  }

  return {
    setFormDocument
  }
}
